import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { States } from '../../model/states';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class StatesService {
  url = environment.API_URL;
  constructor(private http: HttpClient) { }

  getAll(): Observable<States[]>{
    return this.http.get<States[]>(`${this.url}states-info`);
  }

  getById(id:number): Observable<States>{
    return this.http.get<States>(`${this.url}states-info/${id}`);
  }

}
